import styled from 'styled-components'

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
